import { shape, object, string, number, arrayOf } from 'prop-types';

export const markdownRemarkType = shape({
  // eslint-disable-next-line react/forbid-prop-types
  frontmatter: object,
});

export const imageType = shape({
  childImageSharp: shape({
    gatsbyImageData: shape({
      layout: string.isRequired,
      placeholder: shape({
        fallback: string.isRequired,
      }),
      images: shape({
        fallback: shape({
          src: string.isRequired,
          srcSet: string.isRequired,
          sizes: string.isRequired,
        }),
        sources: arrayOf(string).isRequired,
      }),
      width: number.isRequired,
      height: number.isRequired,
    }).isRequired,
  }),
});
